/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CellPresenterBase } from "./CellPresenterBase";
import { CellModel } from "./CellModel";
import { ImageCellModel } from "./ImageCellModel";
import { markType } from "igniteui-react-core";
import { stringStartsWith } from "igniteui-react-core";
/**
 * @hidden
 */
var ImageCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ImageCellPresenter, _super);
    function ImageCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(ImageCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    ImageCellPresenter.prototype.b = function (a) {
        _super.prototype.b.call(this, a);
        var b = a;
        if (a.ar) {
            if (a.aw(CellModel.ed) || a.aw(CellModel.f7)) {
                var c = Math.min(1, Math.max(0, a.b6));
                var d = a.bx * (1 - c);
                this.d.b7 = d;
            }
            if (b.aw(ImageCellModel.kj) || b.aw(ImageCellModel.kk)) {
                this.e(b.kn, b.kg);
            }
            if (b.aw(ImageCellModel.kl) || b.aw(ImageCellModel.ex) || b.aw(ImageCellModel.f6)) {
                this.f(b.ki, b.f, b.h);
            }
            if (b.aw(ImageCellModel.f1)) {
                if (a.t == 1) {
                    this.d.cc();
                }
                else if (a.t == 2) {
                    this.e(b.kn, b.kg);
                }
            }
        }
    };
    ImageCellPresenter.prototype.f = function (a, b, c) {
        this.d.ci(a);
    };
    ImageCellPresenter.prototype.e = function (a, b) {
        var c = a.toLowerCase();
        if (b == 0) {
            b = 4;
        }
        if (stringStartsWith(c, "http") || b == 4) {
            this.d.cf(a, 4);
        }
        if (stringStartsWith(c, "asset") || b == 2) {
            var d = a;
            if (stringStartsWith(c, "asset")) {
                d = a.substr(8);
            }
            this.d.cf(d, 2);
        }
        if (stringStartsWith(c, "drawable") || b == 1) {
            var e = a;
            if (stringStartsWith(c, "drawable")) {
                e = a.substr(11);
            }
            this.d.cf(e, 1);
        }
        if (stringStartsWith(c, "nativeresource") || b == 1) {
            var f = a;
            if (stringStartsWith(c, "nativeresource")) {
                f = a.substr(17);
            }
            this.d.cf(f, 1);
        }
        if (stringStartsWith(c, "embeddedresource") || b == 3) {
            var g = a;
            if (stringStartsWith(c, "embeddedresource")) {
                g = a.substr(19);
            }
            this.d.cf(g, 3);
        }
    };
    ImageCellPresenter.$t = markType(ImageCellPresenter, 'ImageCellPresenter', CellPresenterBase.$);
    return ImageCellPresenter;
}(CellPresenterBase));
export { ImageCellPresenter };
//# sourceMappingURL=ImageCellPresenter.js.map
